<template>
  <div v-show="false">
    <img ref="imageRef" :src="imageUrl" @click="openViewer">
  </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

export default {
  props: {
    imageUrl: {
      default: "",
      type: String
    },
  },
  data () {
    return {
      viewer: null,
    };
  },
  mounted () {
    // 手动创建 Viewer 实例
    this.viewer = new Viewer(this.$refs.imageRef, {
      inline: false,
      // viewed () {
      //   this.viewer.zoomTo(1); // 初始缩放比例
      // }
    });
  },
  beforeDestroy () {
    // 销毁实例避免内存泄漏
    if (this.viewer) {
      this.viewer.destroy();
      this.viewer = null;
    }
  },
  methods: {
    openViewer () {
      this.viewer.show(); // 手动调用 show 方法
    }
  }
};
</script>